// src/components/ui/skeleton.jsx
import React from "react";
import { cn } from "../../lib/utils";

export function Skeleton({ className, ...props }) {
    return (
        <div
            className={cn(
                "animate-pulse rounded-lg bg-zinc-200/80 dark:bg-zinc-800/80",
                className
            )}
            {...props}
        />
    );
}
